<div class="recent-confirmation-code-container" id="conf-code-container" (window:resize)="windowResize()">
  @if (recentConfirmationCodesToShow.length > 0) {
    <div class="recent-confirmation-code-left-margin"></div>
  }
  <div class="recent-confirmation-code-list-container">
    @for (rcc of recentConfirmationCodesToShow; track rcc) {
      <app-recent-confirmation-code-tile
        [id]="rcc.isActive ? 'currentPnr' : 'recentPnr' + rcc.id"
        [ngClass]="{ 'recent-confirmation-code-item-separator': true, 'recent-confirmation-code-item-active': rcc.isActive }"
        [confirmationCode]="rcc.confirmationCode"
        [passengerNames]="rcc.passengerNames"
        [isActive]="rcc.isActive"
        tileClasses="{{
          rcc.isActive
            ? 'recent-confirmation-code-tile-align-center recent-confirmation-code-tile recent-confirmation-code-tile-active'
            : 'recent-confirmation-code-tile-align-center recent-confirmation-code-tile'
        }}"
        appSpaceOrEnterKeySelector
      >
      </app-recent-confirmation-code-tile>
    }
    @if (recentConfirmationCodesInDropdown.length !== 0) {
      <auro-dropdown id="recentConfirmationCodeDropdown" inset rounded [class]="dropdownClasses">
        <auro-menu noCheckmark [style]="dropdownMenuWidth">
          @for (rcc of recentConfirmationCodesInDropdown; track rcc) {
            <auro-menuoption
              [attr.id]="rcc.confirmationCode"
              [attr.value]="rcc.confirmationCode"
              [selected]="rcc.isActive"
              (click)="handleClick()"
            >
              <div>
                <app-recent-confirmation-code-tile
                  class="recent-confirmation-code-list-menuoption"
                  [confirmationCode]="rcc.confirmationCode"
                  [passengerNames]="rcc.passengerNames"
                  alignment="left"
                  [isActive]="rcc.isActive"
                  tileclasses="{{
                    rcc.isActive
                      ? 'recent-confirmation-code-tile-align-left recent-confirmation-code-tile recent-confirmation-code-tile-active'
                      : 'recent-confirmation-code-tile-align-left recent-confirmation-code-tile'
                  }}"
                >
                </app-recent-confirmation-code-tile>
              </div>
            </auro-menuoption>
          }
        </auro-menu>
        <div slot="trigger" id="dropdownTrigger" class="recent-confirmation-code-overflow-menu-trigger" [style]="dropdownTriggerPadding">
          <div class="recent-confirmation-code-overflow-menu-trigger">
            @if (recentConfirmationCodesInDropdown.length > 0) {
              <div class="recent-confirmation-code-overflow-menu-trigger-text">More</div>
            }
            @if (recentConfirmationCodesInDropdown.length > 0 ? true : null) {
              <auro-icon ondark category="interface" name="chevron-down" customColor style="color: #0074c8"></auro-icon>
            }
          </div>
        </div>
      </auro-dropdown>
    }
  </div>
  @if (this.recentConfirmationCodesInDropdown.length > 0) {
    <div class="recent-confirmation-code-right-margin"></div>
  }
</div>
